import { render, staticRenderFns } from "./CorrectionDocumentDropoffForm.vue?vue&type=template&id=24d4251e"
import script from "./CorrectionDocumentDropoffForm.vue?vue&type=script&lang=js"
export * from "./CorrectionDocumentDropoffForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports